import { Loader2, RefreshCw } from 'lucide-react';
import React from 'react';
import { Button } from '../../../components/ui/button';
import {
  useActiveSyncJobsStatus,
  useSyncAutomationTemplates,
} from '../useAutomationTemplates';
import styles from './EngageAutomationsTab.module.css';

const { icon, syncTemplatesContainer, syncButton, disabledExplanation } =
  styles;

const DISABLED_EXPLANATION_TEXT =
  'Sync is disabled because there are active sync jobs in progress for your businesses';

export const SyncTemplatesButton: React.FC = () => {
  const syncTemplatesMutation = useSyncAutomationTemplates();
  const { data, isLoading } = useActiveSyncJobsStatus();

  const hasActiveJobs = data?.hasActiveJobs ?? false;
  const dataIsLoading = isLoading || syncTemplatesMutation.isPending;
  const syncIsDisabled = dataIsLoading || hasActiveJobs;

  const loadingContent = (
    <>
      <Loader2 className={`${icon} animate-spin`} />
      Syncing...
    </>
  );

  const syncTemplatesCallToActionContent = (
    <>
      <RefreshCw className={icon} />
      Sync Templates
    </>
  );

  const buttonContent = syncIsDisabled
    ? loadingContent
    : syncTemplatesCallToActionContent;

  return (
    <div className={syncTemplatesContainer}>
      <Button
        onClick={() => syncTemplatesMutation.mutate()}
        disabled={syncIsDisabled}
        variant="outline"
        className={syncButton}>
        {buttonContent}
      </Button>
      <p
        className={disabledExplanation}
        style={{
          visibility: syncIsDisabled && hasActiveJobs ? 'visible' : 'hidden',
        }}>
        {DISABLED_EXPLANATION_TEXT}
      </p>
    </div>
  );
};
